import React, {useEffect, useState} from 'react';
import {Card, CardContent, Box, Link, Typography} from '@mui/material';
import {
  ChevronDownDark,
  ChevronUpDark,
  Dot,
  Man,
  Ratings,
} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {ABImage} from '@jobseeker/lotus/assets/images';
import {TrackEventUBA} from '@jobseeker/common-core/utils';
import {useInView} from '@jobseeker/lotus/hooks';
import {useRouter} from 'next/router';
import {AppState, JobDetail} from '@jobseeker/common-core/types';
import {useSelector} from 'react-redux';

type ReviewItem = {
  visibility?: boolean;
  data: {
    reviewData: [
      {
        likesText?: string;
        name?: string;
        publishedOn?: string;
        overallCompanyRating?: string;
        title?: string;
        reviewsCount: number;
        reviewLink: string;
      },
    ];
  };
  templateInfo?: {
    templateNo?: string;
    origin?: string;
  };
};
const CompanyReview: React.FC<ReviewItem> = ({data, templateInfo}) => {
  const [showAll, setShowAll] = useState(false);
  const {ref, isInView} = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });
  const router = useRouter();
  const jobInfo: JobDetail = useSelector((state: AppState) => state.jobDetail);

  const [companyReviewsTracked, setCompanyReviewsTracked] = useState(false);

  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  useEffect(() => {
    if (isInView && !companyReviewsTracked) {
      TrackEventUBA('sectionView', 'view', {
        ref: router.query.ref || '',
        pageName: 'JD',
        jobID: jobInfo.id,
        page: 'JD',
        templateID: templateInfo?.templateNo,
        isBranded: 'Yes',
        companyID: jobInfo?.companyData?.companyId,
        centralCompanyID: jobInfo?.recruiter?.centralizedCompanyId,
        companyName: jobInfo?.companyData?.companyName,
        section: 'Reviews',
        sessionUsername: sessionStorage.getItem('userId') || '',
      });
      setCompanyReviewsTracked(true);
    }
  }, [isInView, companyReviewsTracked]);

  return (
    <Box p={2} pb={0.5} px={1.5} ref={ref}>
      <Card
        variant="outlined"
        sx={{
          border: 'none',
          backgroundColor: '#F9FAFB',
        }}
      >
        <CardContent
          sx={{
            padding: 0,
            '&:last-child': {
              pb: 0,
            },
          }}
        >
          {data?.reviewData?.map((b, idx) => (
            <Box key={idx} mb={1.5}>
              <Typography
                fontSize={isAppIimjobs ? 12 : 14}
                fontWeight={500}
                lineHeight={'16px'}
              >
                {b.title}
              </Typography>
              <Box
                display={'flex'}
                alignItems="center"
                gap={0.5}
                mt={0.5}
                mb={1}
              >
                <Image src={Man} height={12} width={12} alt="man" />
                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: 400,
                    color: '#7E7E7E',
                    ml: 0.5,
                  }}
                >
                  {b.name}
                </Typography>
                <Image
                  src={Dot}
                  height={4}
                  width={4}
                  alt="dot"
                  style={{marginLeft: 8, marginRight: 8}}
                />
                <Typography
                  sx={{fontSize: 12, fontWeight: 400, color: '#7E7E7E'}}
                >
                  {b.publishedOn}
                </Typography>
              </Box>
              <Typography
                fontSize={12}
                fontWeight={400}
                fontStyle={'italic'}
                lineHeight={'16px'}
              >
                {b.likesText}
              </Typography>
              <Image
                src={Ratings}
                width={48}
                height={8}
                alt="raing"
                style={{marginTop: 8, marginBottom: 0}}
              />{' '}
              <Box display={'flex'} alignItems="center" marginBottom={'-6px'}>
                <Typography color={'#7E7E7E'} fontSize={10} fontWeight={400}>
                  Powered by:{' '}
                </Typography>
                <a
                  style={{marginLeft: 4, marginTop: '2px'}}
                  title={''}
                  target="_blank"
                  rel="nofollow"
                  href={'https://www.ambitionbox.com/'}
                >
                  <Image
                    height={12}
                    width={65}
                    style={{marginTop: 0}}
                    alt="AmbitionBox"
                    src={ABImage}
                  />
                </a>
              </Box>
            </Box>
          ))}
          {data.reviewData.length > 3 && (
            <Box
              mt={2}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              onClick={() => setShowAll(prev => !prev)}
              sx={{cursor: 'pointer', pb: 1.5}}
            >
              <Link
                color="primary"
                underline="none"
                letterSpacing="0.48px"
                lineHeight="18px"
                fontSize={12}
                fontWeight={500}
              >
                {showAll ? 'Show Less' : 'Show More'}
              </Link>
              <Image
                src={!showAll ? ChevronDownDark : ChevronUpDark}
                alt="chevron"
                height={18}
                width={18}
              />
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default CompanyReview;
